import React from 'react';
import PropTypes from 'prop-types';
import { SHeader, SRow, SCol, STitle, STitleH2, STitleH1 } from './styles';
import { Container } from 'react-bootstrap';
import Breadcrumbs from 'components/Breadcrumbs';

const TitleHeader = ({
  title,
  h1Title = false,
  isBlogPost = false,
  adCampaign = false,
}) => {
  return (
    <SHeader adCampaign={adCampaign}>
      <Container>
        <SRow>
          <SCol>
            {isBlogPost && <STitleH2>{title}</STitleH2>}
            {h1Title ? (
              <STitleH1>{title}</STitleH1>
            ) : (
              !isBlogPost && <STitle>{title}</STitle>
            )}
            {adCampaign ? null : <Breadcrumbs title={title} />}
          </SCol>
        </SRow>
      </Container>
    </SHeader>
  );
};

TitleHeader.propTypes = {
  title: PropTypes.string,
  location: PropTypes.any,
  isBlogPost: PropTypes.bool,
  adCampaign: PropTypes.bool,
  h1Title: PropTypes.bool,
};

export default TitleHeader;
